module.exports = "https://static.moomoo.com/components/common-redpacket/images/act-end.fdd6b25e0d.png";